import { useParams } from 'react-router-dom';

import { FOLDER_NOT_FOUND } from 'hb-react/frontoffice/apps/MediaCenter/utils/queryUtils';

import MediaCenterBlocksRenderer from './BlocksRenderer';
import { useCategories } from './hooks/useCategories';
import { useFolder } from './hooks/useFolder';

const MediaCenterContainer = ({ configPage, topic }) => {
  const tags = useCategories();

  const { folderUuid } = useParams();
  const params = topic ? { folderUuid, topicId: topic.id } : { folderUuid };
  const { currentFolder, error, isLoading } = useFolder(params);

  return (
    <MediaCenterBlocksRenderer
      configPage={configPage}
      currentFolder={currentFolder}
      topic={topic}
      isFolderEmpty={error === FOLDER_NOT_FOUND}
      isLoadingCurrentFolder={isLoading}
      tags={tags}
    />
  );
};

export default MediaCenterContainer;
